/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import CourseRowItem from './CourseRowItem';

/**
 * Example Component
 * @param {Object.data} data Data from UseInfiniteQuery and useRecipes hook
 * @param {Object.currentPage} currentPage The current page of the recipe list
 * @param {Object.isPending} isPending Whether the loading is pending or not (from useIndustries hook)
 * @param {Object.error} error The error of the data fetch (from useRecipes hook)
 * @param {Object.isError} isError Whether the fetch has an error or not (from useIndustries hook)
 * @returns {JSX.Element}
 */
function CourseRows({ data, isPending, isError }) {
	if (isPending) {
		return <div>{__('Loading courses...', 'kotisivu-block-theme')}</div>;
	}

	if (isError) {
		return (
			<div>{__('Error fetching courses.', 'kotisivu-block-theme')}</div>
		);
	}

	return data.map((item) => {
		return (
			<CourseRowItem
				key={item.id}
				id={item.id}
				name={item.title}
				url={item.url}
				start={item.start_date}
				end={item.end_date}
				status={item.status}
				registrationUrl={item.registration_url}
			/>
		);
	});
}

export default CourseRows;
